import { en } from './en';
import type { Locale } from './locale';
import type { Messages } from './messages';
import { nb } from './nb';
import { nn } from './nn';

/**
 * The catalogue per locale (ADR-031) — the one place the three are joined, so adding a locale
 * is a new file plus one entry here (and `Locale` in `locale.ts`, which `Record` then enforces).
 * Pure and DOM-free; the React side (`context.tsx`) picks from here.
 */
export const MESSAGES: Record<Locale, Messages> = { en, nb, nn };

/** The catalogue a locale renders with. */
export function messagesFor(locale: Locale): Messages {
  return MESSAGES[locale];
}
